module.exports = __webpack_public_path__ + "img/shield-03.a3db216a.svg";